import { FONT_FAMILY_ITEM, type FontFamily } from '../constants/font-family';

export type EmailFontFamily = FontFamily;

export function getFontFamily(fontFamily: EmailFontFamily | null | undefined) {
  const value = fontFamily ?? FONT_FAMILY_ITEM.modernSans;

  switch (value) {
    case FONT_FAMILY_ITEM.modernSans:
      return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
    case FONT_FAMILY_ITEM.bookSans:
      return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
    case FONT_FAMILY_ITEM.organicSans:
      return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
    case FONT_FAMILY_ITEM.geometricSans:
      return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
    case FONT_FAMILY_ITEM.heavySans:
      return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
    case FONT_FAMILY_ITEM.roundedSans:
      return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
    case FONT_FAMILY_ITEM.modernSerif:
      return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
    case FONT_FAMILY_ITEM.bookSerif:
      return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
    case FONT_FAMILY_ITEM.monospace:
      return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
  }
}
